export default __webpack_public_path__ + "static/media/badge_active.a08ec35f.svg";